import React, { useEffect } from "react";
import { Container } from "olive-react-myoneui";
import NavigationBarStudentLanding from "../../components/NavigationBarStudentLanding";
import TopHeader from "../../components/TopHeader";
import Footer from "../../components/Footer";
import { API_URL, headers } from "../../constants/config";
import { useSearchParams } from 'react-router-dom';
import { useSelector } from "react-redux";
import { getCodeVersion } from "../../utils/code_version_helper";



function CartReact() {
    const guestCheckout = useSelector((state) => state.user.miscellaneous.guest_checkout);
    const isLoggedIn = useSelector((state) => state.user.user.is_logged_in);
    if (!guestCheckout && !isLoggedIn) {
        window.location.href = "/login";
    }
    const [searchParams, setSearchParams] = useSearchParams();
    const getItem = searchParams.get('item')
//
    // useEffect(() => {
    //     if(getItem == null){
    //         window.location.reload(false);
    //     };
    //   }, [getItem]);

    // console.log(getItem,"getItem")

    const css_api = async () => {
       return await fetch(`${API_URL}api/front_end/cart_css`)
       .then(response=>response.text())
       .then(response =>
        {return(response)})
 
    }

    const loadCart = () => {
        return typeof ReactDOM === 'object' && typeof __invalidCoupon !== "undefined" && typeof window.ReactDOM?.render === 'function';
    }

    const loadScript = (script_src, codeVersion) => {

        let script = document.createElement('script');
        script.src = API_URL + script_src;
        //append code version todo/
        //
        if(script_src == "assets/js/cart/app.min.js"){
            if(process.env.REACT_APP_ENV === "localhost") {
                script.src = `${process.env.REACT_APP_CDN_URL}/${process.env.REACT_APP_CART_FOLDER}/app.min.js`;
            } else {
                script.src = `${process.env.REACT_APP_CDN_URL}/${process.env.REACT_APP_CART_FOLDER}/${process.env.REACT_APP_BRANCH_CODE}/app.min.js?v=${codeVersion}`;
            }
        }
        if(script_src ==  "assets/js/cart/react.production.min.js"){
            if(process.env.REACT_APP_ENV === "localhost") { 
                script.src = `${process.env.REACT_APP_CDN_URL}/${process.env.REACT_APP_CART_FOLDER}/react.production.min.js`;
            } else {
                script.src = `${process.env.REACT_APP_CDN_URL}/${process.env.REACT_APP_CART_FOLDER}/${process.env.REACT_APP_BRANCH_CODE}/react.production.min.js?v=${codeVersion}`;
            }
        }
        if(script_src == "assets/js/cart/react-dom.production.min.js" ){
            if(process.env.REACT_APP_ENV === "localhost") { 
                script.src = `${process.env.REACT_APP_CDN_URL}/${process.env.REACT_APP_CART_FOLDER}/react-dom.production.min.js`;
            } else {
                script.src = `${process.env.REACT_APP_CDN_URL}/${process.env.REACT_APP_CART_FOLDER}/${process.env.REACT_APP_BRANCH_CODE}/react-dom.production.min.js?v=${codeVersion}`;
            }
        }
        document.body.appendChild(script);
        return () => {
            document.body.removeChild(script);
        }
    }

    useEffect(() => {
        css_api()
        .then(response => {
                let newElem = document.createElement("style");
                newElem.innerHTML = response;
                document.getElementsByTagName("head")[0].appendChild(newElem);
        });
        
        getCodeVersion().then(response => {

            const scripts = ["assets/pseudo_files/geolocation.js","assets/pseudo_files/cart_script.js?item="+getItem,"assets/js/jquery.js","assets/js/cart/react.production.min.js", "assets/js/cart/react-dom.production.min.js", "assets/js/cart/app.min.js"];
            scripts.forEach(script_src => {
                if (script_src == "assets/js/cart/app.min.js") {
                    let cartLoadCheckTimer =  setInterval(() => {
                        if (loadCart()) {
                            loadScript(script_src,response);
                            clearInterval(cartLoadCheckTimer);
                        }
                    }, 100);
                } else {
                    loadScript(script_src,response);
                }
            });
        });
        
    }, []);


    const getCountry = async () => {
        // var myHeaders = {
        //     Accept: "application/json",
        //     "Content-Type": "application/json",
        // }
        // var myInit = {
        //   method: 'GET',
        //   headers: myHeaders,
        // };
        let countries = localStorage.getItem("countries");
        if(!countries){
            const res = await fetch(`${API_URL}/mykademy/api/v1/countries`, {
                method: "GET",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                }
            })
            .then((res) => res.json())
            .then((result) => {
                // console.log(result,"result");
                localStorage.setItem('countries',JSON.stringify(result.data));
                // this.setState({ countries: JSON.parse(localStorage.getItem('countries'))});
            });
        }
        }
        
    
      useEffect(() => {
        getCountry();
      }, []);

    return (
        <>
        <TopHeader />
        <NavigationBarStudentLanding />
    <section class="cart-section" id='cartBlock' style={{minHeight: "527px"}}></section>
        {/* <div className="w-100 p-4"> */}
            {/* <Container> */}
               
            {/* </Container> */}
        {/* </div> */}
        
        <Footer />
        </>
    );
}

export default CartReact;